export default function H6({ title, fontWeight = 'normal', theme = "title", underline = false, className = "" }) {
    return (
        <h6 className={`text-xs md:text-sm font-${fontWeight} text-${theme} ${underline ? "underline" : ""} ${className}`}>
            {title}
        </h6>
    );
}
